"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactionType = void 0;
var ReactionType;
(function (ReactionType) {
    ReactionType["Like"] = "Like";
    ReactionType["Heart"] = "Heart";
})(ReactionType = exports.ReactionType || (exports.ReactionType = {}));
//# sourceMappingURL=reaction-type.js.map